const getApp = require('./helpers/app');

const infosCRM = {
    
    BASE_URL: {
        dev: 'https://api-crm.segasp-univalores.com.br',
        prod: 'https://api-crm.segasp-univalores.com.br',
        homolog: 'https://api-crm.segasp-univalores.com.br',
        segasp: 'https://api-crm.segasp-univalores.com.br'
    },

    segasp: {
        multiempresa: false,
    },

    triade: {
        multiempresa: false,
    },

    maisprevidencia: {
        multiempresa: false
    },

    centauro: {
        multiempresa: false,
    },

    alper: {
        multiempresa: false,
    },
    at49: {
        multiempresa: false,
    },
    hz: {
        multiempresa: false,
    },
    valorminas: {
        multiempresa: false,
    },
    bob: {
        multiempresa: false,
    },
    trial: {
        multiempresa: false,
    },

    misterliber: {
        multiempresa: false,
    },

    credicom: {
        multiempresa: false,
    },
    xpro10: {
        multiempresa: false,
    },

    tgl: {
        multiempresa: false,
    },
    sincor: {
        multiempresa: false,
    },

    fcdl: {
        multiempresa: false,
    },
    strati: {
        multiempresa: false,
    },
    maisprotecaofinanceira: {
        multiempresa: false,
    },
    oceanblue: {
        multiempresa: false,
    },
    integrare: {
        multiempresa: false,
    },
    morise: {
        multiempresa: false,
    },
    imperial: {
        multiempresa: false,
    },
    menegon: {
        multiempresa: false,
    },
    tglcontabil: {
        multiempresa: false,
    },
    vivere: {
        multiempresa: false,
    },
    dfbrasil: {
        multiempresa: false,
    },
    local: {
        multiempresa: process.env.MULTIEMPRESA == 1,
    },
    oabprev: {
        multiempresa: false,
    },
    safe: {
        multiempresa: false,
    },
    volant: {
        multiempresa: false,
    },
    planejar: {
        multiempresa: false,

    },
    tudoseguro: {
        multiempresa: false,
    },
    formuladoseguro: {
        multiempresa: false,
    },
    akiva: {
        multiempresa: false,
    },
    seguralta: {
        multiempresa: true,
    },
}

const getAmbiente = () => infosCRM[getApp()] || {multiempresa: false}

const object = {
    infosCRM,
    getAmbiente,
    get ambiente() {
        return this.getAmbiente()
    },

    get isMultiEmpresa() {

        return this.getAmbiente().multiempresa
    }
}

module.exports = object;



// WEBPACK FOOTER //
// ./src/environment.js